import { z } from "zod";

export const filterSchema = z.object({
    id: z.string(),
    operator: z.enum(["is", "not", "gte", "lte"]),
    type: z.enum(["due", "priority", "assignee", "status", "createdBy", "parentTask", "completedAt"]),
    value: z.any(),
});

export type Filter = z.infer<typeof filterSchema>;
